import { z } from 'zod'

/**
 * Job costing verification status (only relevant when tracking_status = TRACKED).
 * - UNVERIFIED: Cost data needs human review
 * - VERIFIED: Cost data has been reviewed and confirmed
 */
export const JobCostingVerificationStatus = z.enum(['UNVERIFIED', 'VERIFIED'])
export type JobCostingVerificationStatus = z.infer<typeof JobCostingVerificationStatus>

/**
 * Get display name for verification status
 */
export function getVerificationStatusDisplayName(status: JobCostingVerificationStatus): string {
  const displayNames: Record<JobCostingVerificationStatus, string> = {
    UNVERIFIED: 'Unverified',
    VERIFIED: 'Verified',
  }
  return displayNames[status]
}

/**
 * Get badge color for verification status (matches Ant Design Badge status)
 */
export function getVerificationStatusBadgeColor(status: JobCostingVerificationStatus): 'warning' | 'success' {
  const colors: Record<JobCostingVerificationStatus, 'warning' | 'success'> = {
    UNVERIFIED: 'warning',
    VERIFIED: 'success',
  }
  return colors[status]
}
